import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'smrts-dialog-confirmacao',
  templateUrl: './dialog-confirmacao.component.html',
  styleUrls: [
    './dialog-confirmacao.component.scss'
  ],
  standalone: false
})

export class DialogConfirmacaoComponent {

  titulo: string = "";
  mensagem: string = "";
  mensagemBold: string = "";
  textoBtnCancelar: string = "Cancelar";
  textoBtnConfirmacao: string = "Confirmar";
  btnBackgroundColor: string = "#4A6572";
  mostrarBtnConfirmar: boolean = true;

  acaoConfirmacao: (...args: any[]) => any = () => {};
  acaoCancelar: (...args: any[]) => any = () => {};

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmacaoComponent>
  ) { }

  confirmar(): void {
    this.acaoConfirmacao();
    this.dialogRef.close(true);
  }

  cancelar(): void {
    this.acaoCancelar();
    this.dialogRef.close(false);
  }
}
